import { styled } from '@mui/material/styles';

import { GRID_DIVIDER } from 'shared/components/Disclaimer/constants';
import { Divider as SharedDivider } from 'shared/components/Divider';

export const Divider = styled(SharedDivider)({
  gridArea: GRID_DIVIDER,
});
